import React, { useMemo } from 'react';
import { Layout, Divider } from 'antd';
import useSWR from 'swr';
import styled from 'styled-components';

const { Content } = Layout;

import { moneyFormatter, useHandleSWR } from '~/libs/helpers'
import { BlockLayout } from './layouts';
import useGlobalState from '~/libs/context';

const StyledSection = styled.div`
  display: flex;
  margin-top: 0px;
  flex-direction: column;
	padding: 8px 0px;
	width: 100%;
`;

const StyledLine = styled.div`
  display: flex;
  width: 100%;
  padding: 0px 2px;

  .title {
    flex: 3;
  }

  .amount {
    flex: 1;
    text-align: right;
  }
`;

const ProfitLoss = () => {
  const { year } = useGlobalState();
	const { data: swrProfitLoss } = useSWR(`/api/metrics/profitLoss?year=${year}`);
  const { data: profitLoss } = useHandleSWR(swrProfitLoss, { sales: [], purchases: [], expenses: [], totals: [] }, true);

  const jsxMonths = useMemo(() => {
    return <StyledLine>
      <div className='title'></div>
      {Array.from({ length: 12 }, (_, i) => <div key={'pnl-month-' + (i + 1)} className="amount">{i + 1}月</div>)}
      <div className="amount">Total</div>
    </StyledLine>;
	}, []);

	const jsxSales = useMemo(() => {
    return profitLoss?.sales.map(entry => 
      <StyledLine key={'pnl-' + entry.account.name}>
        <div className='title'>{entry.account.title}</div>
        {entry.months.map((x, i) => <div key={'pnl-' + entry.account.name + '-' + (i + 1)} className="amount">{moneyFormatter(x)}</div>)}
        <div key={'pnl-' + entry.account.name} className="amount">{moneyFormatter(entry.total)}</div>
      </StyledLine>
    );
	}, [profitLoss]);
	
	const jsxPurchases = useMemo(() => {
    return profitLoss?.purchases.map(entry => 
      <StyledLine key={'pnl-' + entry.account.name}>
        <div className='title'>{entry.account.title}</div>
        {entry.months.map((x, i) => <div key={'pnl-' + entry.account.name + '-' + (i + 1)} className="amount">{moneyFormatter(x)}</div>)}
        <div key={'pnl-' + entry.account.name} className="amount">{moneyFormatter(entry.total)}</div>
      </StyledLine>
    );
	}, [profitLoss]);
	
	const jsxExpenses = useMemo(() => {
    return profitLoss?.expenses.map(entry => 
      <StyledLine key={'pnl-' + entry.account.name}>
        <div className='title'>{entry.account.title}</div>
        {entry.months.map((x, i) => <div key={'pnl-' + entry.account.name + '-' + (i + 1)} className="amount">{moneyFormatter(x)}</div>)}
        <div key={'pnl-' + entry.account.name} className="amount">{moneyFormatter(entry.total)}</div>
      </StyledLine>
    );
  }, [profitLoss]);

  const jsxMonthlyTotals = useMemo(() => {
    return <StyledLine>
      <div className='title'>Totals</div>
      {profitLoss?.totals.map((x, i) => <div key={'pnl-' + (i + 1)}  className="amount">{moneyFormatter(x)}</div>)}
      <div className='amount'>{moneyFormatter(profitLoss.total)}</div>
    </StyledLine>;
	}, [profitLoss]);

	return (
    <BlockLayout>
      <Content>
        <StyledSection>
          {jsxMonths}
        </StyledSection>
        <Divider orientation='left'>Sales</Divider>
        <StyledSection>
          {jsxSales}
        </StyledSection>
        <Divider orientation='left'>Purchases</Divider>
        <StyledSection>
          {jsxPurchases}
        </StyledSection>
        <Divider orientation='left'>Expenses</Divider>
        <StyledSection>
          {jsxExpenses}
        </StyledSection>
        <Divider></Divider>
        <StyledSection>
          {jsxMonthlyTotals}
        </StyledSection>
      </Content>
    </BlockLayout>
	);

};

export default ProfitLoss;